

(function($) {
    // Footer signup form code.
    var token = 'd0ZAqPjFxhvy2gss-aTT_TrtBtrGSwvlQn4Rf8KUCs';

    $(document).ready( function () {
        $('#phone_signup').on('submit', function (event) {
            event.preventDefault();
            var $form = $(this);
            var attentiveVisitorId = document.cookie.replace(/(?:(?:^|.*;\s*)__attentive_id\s*=\s*([^;]*).*$)|^.*$/, "$1");

            $.ajax({
                url: 'https://api.attentivemobile.com/1/add-subscriber',
                headers: {
                    Authorization: 'Bearer ' + token,
                },
                method: 'POST',
                dataType: 'json',
                data: {
                    phone: $form.find('input[name=phone]').val(),
                    visitorId: attentiveVisitorId
                },
                success: function (response) {
                    console.log ( response );
                },
                error: function (error) {
                    console.log ( error );
                }
            });
        });
    });
}(jQuery));
